import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import period from './period'
import homepage from './homepage'
import records from './records'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production', // 在非生产环境下，使用严格模式
  modules: {
    user,
    period,
    homepage,
    records
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js